export default "__VITE_ASSET__DqUZ9$Qy__"